export default __webpack_public_path__ + "static/media/gallery_13.e886ab39.jpg";